<template>
    <div>
        <h3>公司沿革</h3>
        <ul>
            <li>
                <div class="gsyg">
                    <!--公司沿革2019-->
                    <div class="gsyga">
                        <div class="gsygleft">
                            <h5 style="text-align:right; margin-bottom: 8px">2019年药聚多湖南运营分中心成立</h5>
                            <h6 style="color:darkgrey ">
                                6月，药聚多与湖南智祥医药股份有限公司达成战略合作伙伴关系，双方携手共同建立湖南首个运营分中心，为全国客户尤其是华中、华南地区的药聚多客户提供更加优质的产品及配送服务。
                            </h6>
                        </div>
                        <div class="gsygright">
                            <h4>2019</h4>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <!--公司沿革2018-->
                    <div class="gsyga">
                        <div class="gsygleft">
                            <h4>2018</h4>
                        </div>
                        <div class="gsygright">
                            <h5 style="margin-bottom: 8px"><strong>2018年公司与安徽华源提前续签战略合作协议，双方持续保持战略合作伙伴关系</strong></h5>
                            <h6 style="color:darkgrey ">
                                双方选择在协议到期前提前续约，标志着双方对前期合作取的成果非常满意，并为双方在未来的合作发展前景充满信心。
                            </h6>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <!--公司沿革2016-->
                    <div class="gsyga">
                        <div class="gsygleft">
                            <h5 style="text-align:right; margin-bottom: 8px">2016年药聚多移动APP安卓/ios同步开通上线</h5>
                            <h6 style="color:darkgrey ">药聚多APP的开通上线，为终端客户带来更为高效、便捷的药品采购体验，实现网上搜药、下单 、购买等一站式服务。</h6>
                        </div>
                        <div class="gsygright">
                            <h4>2016</h4>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <!--公司沿革2014-->
                    <div class="gsyga">
                        <div class="gsygb">
                            <div class="gsygleft">
                                <h4>2014</h4>
                            </div>
                            <div class="gsygright">
                                <h5 style="margin-bottom: 8px"><strong>2014年汉宁医药网更名为药聚多</strong></h5>
                                <h6 style="color:darkgrey ">
                                    药聚多品牌的建立标志公司业务模式、系统、品牌等体系都已构建完善。
                                </h6>
                                <div class="smallbt"><strong>2014年更多的卖家陆续入驻药聚多平台</strong></div>
                                <h6 style="margin-top: 8px;color:darkgrey">
                                    其他卖家品种是华源品种的有利补充，极大丰富了系统的品类，终端采购药品又多了一份选择。
                                </h6>
                            </div>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <!--公司沿革2013-->
                    <div class="gsyga">
                        <div class="gsygleft">
                            <h5 style="text-align:right; margin-bottom: 8px">2013年公司获得国家药监局批准的互联网药品第三方交易服务资质（国A20130004）</h5>
                        </div>
                        <div class="gsygright">
                            <h4>2013</h4>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <!--公司沿革2011-->
                    <div class="gsyga">
                        <div class="gsygb">
                            <div class="gsygleft">
                                <h4>2011</h4>
                            </div>
                            <div class="gsygright">
                                <h5 style="margin-bottom: 8px"><strong>2011年华源医药网络营销中心新大楼启用剪彩</strong></h5>
                                <h6 style="color:darkgrey ">
                                    在安徽华源医药股份有限公司的大力支持下，华源网络营销中心大楼正式投入使用。
                                </h6>
                                <div class="smallbt"><strong>2011年创业者模式全面推广</strong></div>
                                <h6 style="margin-top: 8px;color:darkgrey">
                                    经过09、10两年的市场检验，创业者模式已经在行业内崭露头角，2011年模式全面推广。
                                </h6>
                            </div>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <!--公司沿革2010-->
                    <div class="gsyga">
                        <div class="gsygleft">
                            <h5 style="text-align:right; margin-bottom: 8px">2010年安徽华源医药与北京汉宁恒丰签署电子商务战略框架协议</h5>
                            <h6 style="color:darkgrey ">
                                双方精诚合作，优势互补，互利共赢，以及发展和完善适合中国国情的医药行业流通新模式。
                            </h6>
                        </div>
                        <div class="gsygright">
                            <h4>2010</h4>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <!--公司沿革2009-->
                    <div class="gsyga">
                        <div class="gsygleft">
                            <h4>2009</h4>
                        </div>
                        <div class="gsygright">
                            <h5 style="margin-bottom: 8px"><strong>2009年汉宁恒丰医药科技股份有限公司成立</strong></h5>
                            <h6 style="color:darkgrey ">
                                安徽华源医药电子商务公司（太和公司）改名为华源网络营销中心，也即为北京汉宁恒丰医药科技股份有限公司太和分公司。汉宁医药网(药聚多平台前身)上线，开始探索创业者模式（区域合作伙伴模式）。
                            </h6>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <!--公司沿革2006-->
                    <div class="gsyga">
                        <div class="gsygleft">
                            <h5 style="text-align:right; margin-bottom: 8px">2006年华源医药电子商务北京公司成立</h5>
                            <h6 style="color:darkgrey ">
                                华源医药网转型为综合性门户网站，在信息聚合和数据分析方面独树一帜。
                            </h6>
                        </div>
                        <div class="gsygright">
                            <h4>2006</h4>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <!--公司沿革2003-->
                    <div class="gsyga">
                        <div class="gsygleft">
                            <h4>2003</h4>
                        </div>
                        <div class="gsygright">
                            <h5 style="margin-bottom: 8px"><strong>2003年安徽华源医药电子商务有限公司成立（公司前身）</strong></h5>
                            <h6 style="color:darkgrey ">
                                公司致力于医药商务服务和信息服务，旗下的华源医药网是国家食品药品监督管理总局批准的信息经营性网站。
                            </h6>
                        </div>
                        <div class="clear"></div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
  name: 'History'
}
</script>
<style lang="less" scoped>
    @url:"../../assets/";
    body, div, img, ul, ol, dl, li, dd, dt, p, span, h1, h2, h3, h4, h5, h6, a, form, select, input, option, strong, iframe {
        padding: 0;
        margin: 0;
        border: 0;
    }
    .yjdleft ul li p {
        margin-bottom: 30px;
        text-indent: 2em;
    }
    .gsyg { width: 960px; background: url('@{url}04-关于药聚多-02_03.jpg') no-repeat; }

    .gsyga {
        padding-top: 45px;
    }

    .gsygleft {
        width: 441px;
        float: left;
        padding-right: 10px;
    }

    .gsygleft h5 {
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        font-family: Arial, Helvetica, sans-serif;
    }

    .gsygleft h4 {
        font-size: 24px;
        color: #d75049;
        line-height: 22px;
        text-align: right;
    }

    .gsygleft h6 {
        font-size: 14px;
        color: #666666;
        line-height: 22px;
        font-family: Arial, Helvetica, sans-serif;
        font-weight: normal;
    }

    .gsygright {
        width: 509px;
        float: left;
    }

    .gsygright h4 {
        font-size: 24px;
        color: #d75049;
        line-height: 22px;
        background: url('@{url}04-关于药聚多-031_06.jpg') no-repeat;
        padding-left: 30px;
    }

    .gsygright h5 {
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        font-family: Arial, Helvetica, sans-serif;
        background: url('@{url}04-关于药聚多-031_06.jpg') no-repeat;
        padding-left: 30px;
    }

    .gsygright h6 {
        font-size: 14px;
        color: #666666;
        line-height: 22px;
        font-family: Arial, Helvetica, sans-serif;
        padding-left: 30px;
        font-weight: normal;
    }

    .smallbt {
        font-size: 16px; color: #333333; line-height: 22px;
        font-family: Arial, Helvetica, sans-serif;
        background: url('@{url}04-关于药聚多-031_10.png') no-repeat 6px 25px; padding-left: 30px; padding-top: 20px;
    }
</style>
